import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { LockOpen } from "@phosphor-icons/react";

export default function ReopenDayDialog({ warehouseName, onConfirm }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm();
      setOpen(false);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <button
          data-testid="reopen-day-btn"
          className="inline-flex items-center gap-2 bg-white border border-amber-300 text-amber-700 hover:bg-amber-50 rounded-md font-semibold px-4 py-2 text-sm transition-colors duration-200"
        >
          <LockOpen size={16} weight="bold" />
          Reopen Day
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="reopen-day-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">Reopen the day for {warehouseName}?</AlertDialogTitle>
          <AlertDialogDescription>
            The day will be unlocked so entries can be edited again. It stays open until{" "}
            <span className="font-semibold text-slate-900">midnight</span>, when it closes
            automatically as the new day begins. The report in the archives updates once it is closed again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="reopen-day-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="reopen-day-confirm"
            onClick={confirm}
            disabled={busy}
            className="bg-amber-500 hover:bg-amber-600 text-white"
          >
            {busy ? "Reopening..." : "Yes, Reopen the Day"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
